import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { MailchimpForm } from './form-elements';

function NewsletterSignup() {
  const { register, handleSubmit } = useForm();

  const [message, setMessage] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <div className="px-4 py-24 bg-light-gray sm:px-6 lg:px-8">
      <MailchimpForm
        handleSubmit={handleSubmit}
        register={register}
        setIsSubmitting={setIsSubmitting}
        setMessage={setMessage}
        name="mailchimp_form"
      >
        <label htmlFor="email" className="block space-y-8">
          <div className="text-3xl font-medium tracking-wider text-center uppercase">
            Get exclusive offers &amp; updates
          </div>

          <div className="flex w-full max-w-2xl mx-auto mt-1">
            <input
              ref={register}
              id="email_address"
              name="email_address"
              placeholder="Email address"
              className="relative flex-grow block w-full pl-6 transition duration-150 ease-in-out border-none rounded-none form-input focus:z-10 placeholder-dark-pink"
            />
            <button
              type="submit"
              className={`relative -ml-px uppercase button ${
                isSubmitting ? 'opacity-50 cursor-wait' : ''
              }`}
            >
              Join
            </button>
          </div>
        </label>
        {message && (
          <div
            dangerouslySetInnerHTML={{ __html: message }}
            className="mt-4 text-center"
          />
        )}
      </MailchimpForm>
    </div>
  );
}

export { NewsletterSignup };
